/**
 * The Flow-Optimizer tags a rule group can test, unioned across the layers the
 * group applies to (with each tag's color + emoji). FO tag rules are stored per
 * layer, so a group spanning paths+landers offers the tags from both. Fetches
 * are cached by react-query.
 * For Media Devoted | Created By Ciro Autiero
 */

import { ALL_LAYERS, type FlowLayer } from '@trafficpulse/shared';

import { useFlowTagRules } from '@/hooks/smswiser/lists/useFlowTagRules';

import type { GroupTag } from './rule-condition/kind/condition-kind';

export function useGroupTags(appliesTo: ReadonlyArray<FlowLayer>): GroupTag[] {
  const byLayer: Record<FlowLayer, ReturnType<typeof useFlowTagRules>> = {
    paths: useFlowTagRules('paths'),
    landers: useFlowTagRules('landers'),
    offers: useFlowTagRules('offers'),
  };
  // Dedup by name across layers; the first layer with the name wins its color/emoji.
  const byName = new Map<string, GroupTag>();
  for (const layer of ALL_LAYERS) {
    if (!appliesTo.includes(layer)) continue;
    for (const rule of byLayer[layer].data ?? []) {
      if (!byName.has(rule.name)) {
        byName.set(rule.name, { name: rule.name, color: rule.color, emoji: rule.emoji });
      }
    }
  }
  return [...byName.values()];
}
